import React from "react";
import "./style.scss";

const Cookies = ({ cookiesClick, cookiesNotView, startQuiz }) => {
  return (
    <div
      className={`cookies cookie__policy-wrap ${cookiesNotView ? "cookiesNotView" : ""} ${startQuiz ? "startQuiz" : ""} hide`}
    >
      <div className={"cookies__wrapper"}>
        <div className={"cookies__title"}>
          We use cookies to make your experience better! If you continue to use
          this site we will assume that you are happy with it.
        </div>
        <div
          className={"cookies__button accept"}
          onClick={() => cookiesClick()}
        >
          Agree <br className="br-mobile" /> & Close
        </div>
      </div>
    </div>
  );
};

export default Cookies;
